export default __webpack_public_path__ + "static/media/supervision2_horizontal_nobg.a3b253db.svg";